export type PoolItem = {
  id: string
  name: string
  apr?: number
  liquidity?: number
  stakedBalance?: string
  earned?: string
  rewardSymbol?: string
  stakingSymbol?: string
  isFinished?: boolean
  isArchived?: boolean
}

const POOLS_API_BASE = process.env.REACT_APP_FARMS_API_BASE || ''

const getUrl = (path: string) => {
  if (!POOLS_API_BASE) return path
  return `${POOLS_API_BASE}${path}`
}

export const fetchPools = async (): Promise<PoolItem[]> => {
  const response = await fetch(getUrl('/pools'))
  if (!response.ok) {
    throw new Error('Failed to fetch pools')
  }
  const data = await response.json()
  return Array.isArray(data) ? data : data?.pools || []
}
